





















import { Component, Vue,Watch } from 'vue-property-decorator'
import { VQuery, VTable, QueryModel, TableHander, TableOperation } from '@/components/table'
import { QueryGoodsList,QueryGoodsCounts, DeleteGoods, UpdateGoodsStatus, QuerySupplierList, QueryAllShopNameList ,BatchUpdateGoodsStatus,BatchDeleteGoods, ExportGoods, UpdateGoodsMian, GetCurrentPlatform, QueryActivityList} from '@/api'
import { DateFormat } from '@/utils/date/DateUtil'
import { Message, MessageBox } from 'element-ui'
import CreateGoodsDialog from './CreateGoodsDialog.vue'
import UpdateGoodsDialog from './UpdateGoodsDialog.vue'
import DescGoodsDialog from './DescGoodsDialog.vue'
import { getNameById } from '@/store/classifyStore'
import {PriceFormat,GoodsStatusFormat} from '@/utils/tyepconvert'
import constant from '@/utils/constant'
import {getUser} from '@/store/userStore'
import { getByParentId } from '@/store/classifyStore'

@Component({
  components: {
    VQuery,
    VTable,
    CreateGoodsDialog,
    UpdateGoodsDialog,
    DescGoodsDialog,
  },
})
export default class GoodsList extends Vue {
  private queryParam = {
    startRow: 1,
    limit: 10,
    sortType: 0,
    goodsOneClassifyId: undefined,
    goodsTwoClassifyId: undefined,
    goodsThreeClassifyId: undefined,
    distributionGoodsFlagEq: null as number | null,
    activityIdFilter: null as number | null,
  }
  private goodsCounts = {
    saleingCount:0,
    saleOverCount:0,
    putDownCount:0,
    auditCount: 0,
    auditErrorCount: 0,
  }
  private tableTotal = 0
  private tableData = []
  private tableCurrntPage = 1
  private activeMenu = 'ALL'
  private canManageMiandan = false // 是否可以管理中转站功能

  private supplierOption: Array<any> = []
  private shopIdOption: Array<any> = []
  private activityOption: Array<any> = [
    { label: '不限', value: null },
    { label: '已关联任意活动', value: -1 },
  ]
  private supplierQueryParam: QueryModel = { title: '供应商', param: 'specifiedSupplierCode' , type: 'select', selectData:  this.supplierOption}
  private shopIdQueryParam: QueryModel = { title: '店铺', param: 'shopId' , type: 'select', selectData:  this.shopIdOption,show:()=>{return this.userInfo.user.role != 2}}
  private activityQueryParam: QueryModel = { title: '关联活动', param: 'activityIdFilter', type: 'select', selectData: this.activityOption }

  private  userInfo = getUser()
  // 查询条件
  private queryModels: Array<QueryModel> = [
    // { title: '排序方式', param: 'sortType' , type: 'select', selectData: constant.SortType},
    // this.supplierQueryParam,
    this.shopIdQueryParam,
    { title: '店铺类型', param: 'shopTypeFilter', type: 'select', selectData: constant.ShopTypeFilter, show:()=>{return this.userInfo.user.role != 2} },
    { title: '排序方式', param: 'goodsSortType', type: 'select', selectData: constant.GoodsSortType },
    { title: '商品名称', param: 'goodsName' },
    { title: '供应链名称', param: 'supplyChainName' },
    { title: '工厂名称', param: 'factoryName' },
    { title: '商品编号', param: 'goodsCode' },
    { title: '一级分类', param: 'goodsOneClassifyId',type: 'select', selectData:  this.goodsOneClassifyData },
    { title: '二级分类', param: 'goodsTwoClassifyId',type: 'select', selectData: [], disabled: ()=>{return this.queryParam.goodsOneClassifyId ? false : true} },
    { title: '三级分类', param: 'goodsThreeClassifyId',type: 'select', selectData:  [], disabled: ()=>{return this.queryParam.goodsTwoClassifyId ? false : true} },
    { title: '是否为分销商品', param: 'distributionGoodsFlagEq', type: 'select', selectData: [
      { label: '不限', value: null },
      { label: '是', value: 1 },
      { label: '否', value: 0 },
    ] },
    this.activityQueryParam,
  ]
  // 全局操作
  private queryOperation: Array<TableOperation> = [
    { title: '创建商品', type: 'primary', click: this.createGoods },
    { title: '批量上架', type: 'primary', click: this.batchUpp },
    { title: '批量下架', type: 'primary', click: this.batchDown },
    { title: '批量删除', type: 'primary', click: this.batchDelete },
    { title: '导出商品', type: 'primary', click: this.exportGoodsHandle },
  ]
  // 数据表头
  private tableHander: Array<TableHander> = [
    { title: '多选', type: 'selection' },
    { title: '序号', param: 'id', type: 'index' },
    // { title: '供应商编号', param: 'supplierCode' },
    { title: '店铺', param: 'shopId' ,formatter: this.shopNameForam, overflow: true,hide:this.userInfo.user.role == 2},
    { title: '商品编号', param: 'goodsCode' , overflow: true,width:200},
    { title: '商品名称', param: 'goodsName' , overflow: true,width:200},
    { title: '供应链名称', param: 'supplyChainName', overflow: true, width: 140 },
    { title: '工厂名称', param: 'factoryName', overflow: true, width: 140 },
    { title: '分销商品', param: 'distributionGoodsFlag', width: 100, formatter: this.formatDistributionGoodsFlag },
    { title: '商品图片', param: 'goodsBanners' , width: 80 , type:'image', formatter: this.getGoodsBanner },
    { title: '一级分类', param: 'goodsOneClassifyId' , formatter: getNameById},
    { title: '二级分类', param: 'goodsTwoClassifyId' ,formatter: getNameById},
    { title: '三级分类', param: 'goodsThreeClassifyId' ,formatter: getNameById},
    // { title: '标签', param: 'goodsLabel' },
    // { title: '单位', param: 'goodsUnit' },
    { title: '销售价', param: 'showPrice' ,formatter: this.showPriceFormat},
    // { title: '奖励积分', param: 'rewardIntegral' ,formatter: PriceFormat},
    { title: '原价', param: 'marketPrice' ,formatter: PriceFormat},
    { title: 'PV', param: 'minPv' ,formatter: this.showPvFormat},
    // { title: '贡献值', param: 'profferValue' ,formatter: PriceFormat},
    // { title: '能力值', param: 'capacityValue' ,formatter: PriceFormat},
    { title: '库存', param: 'inventory' },
    { title: '销量', param: 'buyCount', hide: this.userInfo.user.role == 2 },
    { title: '状态', param: 'goodsStatus' ,formatter: GoodsStatusFormat},
    { title: '排序', param: 'sort' ,hide:this.userInfo.user.role == 2},
    { title: '创建时间', param: 'createTime', formatter: DateFormat,width:160 },
    {
      title: '操作',
      width: 220,
      fixed: 'right',
      operation: [
        // { title: '查看详情', icon: 'el-icon-document',click: this.openDesc },
        { title: '上架', icon: 'el-icon-edit',click: this.shangjia, show: (data: any)=>{return data.goodsStatus == 0 || data.goodsStatus == 3} },
        { title: '下架', icon: 'el-icon-edit',click: this.xiajia, show: (data: any)=>{return data.goodsStatus == 1} },
        { title: '中转站', icon: 'el-icon-edit',click: this.miandan, show: (data: any)=>{
          return data.isTransferStation == 0 && this.canShowMiandanButtons;
        } },
        { title: '取消中转站', icon: 'el-icon-edit',click: this.miandan2, show: (data: any)=>{
          return data.isTransferStation == 1 && this.canShowMiandanButtons;
        } },
        { title: '撤销', icon: 'el-icon-edit',click: this.chexiao, show: (data: any)=>{return data.goodsStatus == 2} },
        { title: '编辑', icon: 'el-icon-edit',click: this.openUpdate },
        { title: '查看评论', icon: 'el-icon-chat-line-square', click: this.openCommentList },
        { title: '删除', icon: 'el-icon-delete', class: 'red', click: this.deleteRow },
      ],
    },
  ]

  public get goodsOneClassifyData(){
    return this.classifyTree(0)
  }

  // 添加计算属性确保权限检查是响应式的
  public get canShowMiandanButtons() {
    const userRole = this.userInfo?.user?.role
    const result = userRole == 1 || userRole== 105 // 使用宽松比较
    console.log('计算属性 canShowMiandanButtons:', {
      userRole,
      userRoleType: typeof userRole,
      result,
      canManageMiandan: this.canManageMiandan
    })
    return result
  }

  @Watch("queryParam.goodsOneClassifyId")
  private goodsOneClassifyWatch(){
    console.log("goodsOneClassifyId",this.queryParam.goodsOneClassifyId)
    if(this.queryParam.goodsOneClassifyId){
      const d = this.classifyTree(this.queryParam.goodsOneClassifyId)
      this.queryModels[8].selectData = d
    } else {
      this.queryModels[8].selectData = []
    }
    this.queryParam.goodsTwoClassifyId = undefined
    this.queryParam.goodsThreeClassifyId = undefined
  }

  @Watch("queryParam.goodsTwoClassifyId")
  private goodsTwoClassifyWatch(){
    console.log("goodsTwoClassifyId",this.queryParam.goodsTwoClassifyId)
    if(this.queryParam.goodsTwoClassifyId){
      const d = this.classifyTree(this.queryParam.goodsTwoClassifyId)
      this.queryModels[9].selectData = d
    } else {
      this.queryModels[9].selectData = []
    }
    this.queryParam.goodsThreeClassifyId = undefined
  }


  private tableSelectData: any[] = []
  private tableSelectChange(e:any[]){
    this.tableSelectData = e
  }

  private classifyTree(parentId: number | undefined) {
    if(parentId == undefined){
      return []
    }
    const d = getByParentId(parentId)
    d.forEach((e:any)=>{
      e.label = e.classifyName
      e.value = e.id
    })
    return d
  }

  private exportGoodsHandle(){

    const loading = this.$loading({
          lock: true,
          text: '正在导出商品明细',
          spinner: 'el-icon-loading',
          background: 'rgba(0, 0, 0, 0.7)'
        });
      const param: any = this.getRequestParam()
      param.limit = ""
      param.startRow = ""

      if(this.tableSelectData.length > 0){
        const ids = this.tableSelectData.map(e=>e.id)
        param.ids = ids
      }


      ExportGoods(param,"商品明细.xlsx").then(res=>{
        loading.close()
      }).catch(()=>{
        loading.close()
      })

  }

  public batchUpp(){
    if(this.tableSelectData.length<=0){
        this.$message.error("请选择商品")
        return
    }
    MessageBox.confirm('确定要上架吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchUpdateGoodsStatus({ idList: this.tableSelectData.map(item=>item.id), goodsStatus: 1 })
      if (ruslt) {
        Message.success('上架成功')
        this.loadData()
      }
    })
  }

    public batchDelete() {
       if(this.tableSelectData.length<=0){
        this.$message.error("请选择商品")
        return
    }
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchDeleteGoods({ idList: this.tableSelectData.map(item=>item.id) })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }

  public batchDown(){
    if(this.tableSelectData.length<=0){
        this.$message.error("请选择商品")
        return
    }
    MessageBox.confirm('确定要下架吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await BatchUpdateGoodsStatus({ idList: this.tableSelectData.map(item=>item.id), goodsStatus: 0 })
      if (ruslt) {
        Message.success('下架成功')
        this.loadData()
      }
    })
  }

  public async created() {
    this.checkUserPermissions() // 检查用户权限
    this.loadData()
    // await this.loadSupplier()
    this.loadShop()
    this.loadActivityOptions()
  }

  // 检查用户权限
  private checkUserPermissions() {
    try {
      // 直接使用已有的用户信息，与其他地方的逻辑保持一致
      const userRole = this.userInfo?.user?.role
      
      // role = 1: 平台管理员, role = 2: 店铺人员
      // 使用宽松比较，因为可能存在字符串和数字的类型转换问题
      this.canManageMiandan = userRole == 1
      
      // 如果没有获取到角色信息，默认不允许管理中转站
      if (userRole === undefined || userRole === null) {
        this.canManageMiandan = false
      }
    } catch (error) {
      console.error('检查用户权限失败:', error)
      this.canManageMiandan = false
    }
  }

  private activeMenuSelect(e:string){
    if(this.activeMenu == e){
      return
    }
    this.activeMenu = e
    this.search()
  }

  private async loadShop() {
    const res = await QueryAllShopNameList({})
    const list = res.list
    this.shopIdOption = list.map((e: any) => {
      return { value: e.id, label: e.name }
    })

    this.shopIdQueryParam.selectData = this.shopIdOption

  }

  private async loadActivityOptions() {
    try {
      const res = await QueryActivityList({ startRow: 0, limit: 500 })
      const list = res?.list || []
      this.activityOption = [
        { label: '不限', value: null },
        { label: '已关联任意活动', value: -1 },
        ...list.map((e: any) => ({
          label: `${e.activityName || '未命名'}（ID:${e.id}）`,
          value: e.id,
        })),
      ]
      this.activityQueryParam.selectData = this.activityOption
    } catch (e) {
      console.error('加载活动列表失败', e)
    }
  }

  private async loadSupplier(){
     const res = await QuerySupplierList({})
    const list =  res.list
    this.supplierOption = list.map((e: any)=>{
      return {value: e.supplierCode,label:e.supplierSimpleName}
    })
    this.supplierQueryParam.selectData = this.supplierOption
  }

  private getGoodsBanner(value: string){
    if(value){
      const vs = value.split(",")
      console.log("vs")
      console.log(vs)
      return vs[0]
    }
    return ""
  }

  public createGoods() {
    (this.$refs.createGoodsDialog as CreateGoodsDialog).open('add')
    // this.$router.push("/createGoodsPage")
  }
  public openUpdate(data: any) {
    (this.$refs.createGoodsDialog as CreateGoodsDialog).open('update',data.goodsCode)
  }

  public openCommentList(data: any) {
    this.$router.push({
      path: '/goodsCommentList',
      query: {
        goodsId: String(data.id),
        goodsName: data.goodsName || '',
      },
    })
  }

  public openDesc(data: any){
    (this.$refs.descGoodsDialog as DescGoodsDialog).open(data.goodsCode)
  }
  public shangjia(data: any){
    MessageBox.confirm('确定要上架吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsStatus({ id: data.id, goodsStatus: 1 })
      if (ruslt) {
        if(this.userInfo.user.shop && !this.userInfo.user.shop.directSales){
          Message.success('已提交上架审核')
        } else {
          Message.success('上架成功')
        }
        this.loadData()
      }
    })
  }
  public xiajia(data: any){
    MessageBox.confirm('确定要下架吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsStatus({ id: data.id, goodsStatus: 0 })
      if (ruslt) {
        Message.success('下架成功')
        this.loadData()
      }
    })
  }

   public miandan(data: any){
    MessageBox.confirm('确定要设为中转站吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsMian({ id: data.id, goodsMian: 1 })
      if (ruslt) {
        
       Message.success('设置成功')
       
        this.loadData()
      }
    })
  }

  public miandan2(data: any){
    MessageBox.confirm('确定要取消中转站吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsMian({ id: data.id, goodsMian: 0 })
      if (ruslt) {
        
       Message.success('取消成功')
       
        this.loadData()
      }
    })
  }
  

  public chexiao(data: any){
    MessageBox.confirm('确定要撤销吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await UpdateGoodsStatus({ id: data.id, goodsStatus: 0 })
      if (ruslt) {
        Message.success('撤销成功')
        this.loadData()
      }
    })
  }

  public async loadData() {

    const param = this.getRequestParam()
    const result = await QueryGoodsList(param)
    this.tableTotal = result.total
    this.tableData = result.list

    // 确保每个商品都有 isTransferStation 字段，如果没有则设置默认值
    if (this.tableData && this.tableData.length > 0) {
      this.tableData.forEach((item: any) => {
        if (item.isTransferStation === undefined || item.isTransferStation === null) {
          item.isTransferStation = 0
        }
      })
    }

    const res2 = await QueryGoodsCounts(param)
    this.goodsCounts = res2
    
    // 数据加载完成后再次检查权限，确保按钮显示正确
    this.checkUserPermissions()
  }

  private getRequestParam(){
    // 排序
    const param: any = { ...this.queryParam }
    
    // 根据 goodsSortType 设置排序方式
    if (param.goodsSortType !== undefined && param.goodsSortType !== null) {
      if (param.goodsSortType === 0) {
        // 按创建时间排序
        param.orderBy = "create_time desc"
      } else if (param.goodsSortType === 1) {
        // 按sort字段排序
        param.orderBy = "sort desc, create_time desc"
      }
    } else if (this.queryParam.sortType == 0) {
      // 默认排序（兼容旧逻辑）
      param.orderBy = "sort desc, create_time desc"
    }
    
    param.startRow =  (this.tableCurrntPage - 1) * (param.limit || 12)

    // 根据选择菜单的不同查询不同的数据
    if(this.activeMenu == 'Saleing'){
      // 售卖中
      param.goodsStatus = 1
       param.inventoryGe = 1
    } else if(this.activeMenu == 'SaleOveer'){
      // 已售罄
      param.goodsStatus = 1
      param.inventory = 0
    } else if(this.activeMenu == 'PutDown'){
      // 已下架
      param.goodsStatus = 0
    } else if(this.activeMenu == 'auditCount'){
      // 审核中
      param.goodsStatus = 2
    }  else if(this.activeMenu == 'auditErrorCount'){
      // 审核失败
      param.goodsStatus = 3
    }
    return param
  }

  public search() {
    console.log(this.queryParam)
    this.tableCurrntPage = 1
    this.loadData()
  }
  // 分页导航改变
  public pageChange(index: number) {
    this.tableCurrntPage = index
    this.loadData()
  }

  public sizeChange(index: number) {
    this.tableCurrntPage = 1
    this.queryParam.limit = index
    this.loadData()
  }

  // 删除单行数据
  public deleteRow(data: any) {
    MessageBox.confirm('确定要删除吗？', '提示', {
      type: 'warning',
    }).then(async () => {
      const ruslt = await DeleteGoods({ id: data.id })
      if (ruslt) {
        Message.success('删除成功')
        this.loadData()
      }
    })
  }
  // 显示价格
  private showPriceFormat(v:any,row:any){
    let showPrice = ''
    if(row.minPrice == row.maxPrice){
      showPrice = PriceFormat(row.minPrice)
    } else {
      showPrice = PriceFormat(row.minPrice) + '~' + PriceFormat(row.maxPrice)
    }
    return showPrice
  }
  // 显示Pv
  private showPvFormat(v:any,row:any){
    let showPv = ''
    if(row.minPv == row.maxPv){
      showPv = PriceFormat(row.minPv)
    } else {
      showPv = PriceFormat(row.minPv) + '~' + PriceFormat(row.maxPv)
    }
    return showPv
  }
  private formatDistributionGoodsFlag(v: any) {
    if (v === 1 || v === '1') {
      return '是'
    }
    return '否'
  }

  // 显示店铺名称
  private shopNameForam(v:number){
    const t = this.shopIdOption.find(e=>e.value == v)
    if(t){
      return t.label
    }
    return v
  }
}
